import { GraphLayoutDetail } from '../_models/Questions/question.interface';
export class QuestionInfo {
    IsDel: boolean = false;
    IsMarked: boolean = false;
    ChoiceIDs: any;
    ChoiceValues: any;
    TimeSpentOnEachQuestion: number;
    IsTimeout: boolean;
    AudioRefId: string = '';
    IsOfflineAttempt: boolean = false;
    QType: string;
    EssayTitle: string = '';
    EssayMode: string = '';
    IsEvaluatedStatusPresented: boolean = false;
    FeedbackSelfEvaluationResponse: string = "";
    MetaDataValue: string;
    IsHintsClicked: boolean = false;
    graphDetails: any
    graphLayoutDetails: GraphLayoutDetail
    constructor(qtype: string, isMarked: boolean,
        IsDel: boolean, prevquestion: any, totalsecs: number, MetaDataName: string, IsHintsClicked: boolean) {
        this.QType = qtype;
        this.IsDel = IsDel;
        this.IsMarked = isMarked;
        this.TimeSpentOnEachQuestion = totalsecs;
        this.MetaDataValue = MetaDataName;
        this.IsHintsClicked = IsHintsClicked;
    }
}
export class TestInformation {
    public QuestionInfo: any;
    public QuestionList: any;
    public QuestionChildrens: any;
}


// WEBPACK FOOTER //
// E:/Workspace/TestandAssessment/Manifest/TestPlayer/TestDelivery.TestPlayer/src/app/_models/Question.ts